import { jsx } from "react/jsx-runtime";
import { ProductListComponentWUT } from "../../../ui/product-list/product-list-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const ProductListWUT = (props) => {
  const { fieldType = FIELD_TYPES.PRODUCT_LIST } = props;
  return /* @__PURE__ */ jsx(ProductListComponentWUT, { ...props, fieldType });
};
export {
  ProductListWUT
};
//# sourceMappingURL=product-list-wut.js.map
